module.exports = __webpack_public_path__ + "static/media/hosp3.7bdff765.jpg";